module.exports = __webpack_public_path__ + "static/media/cinema.b9822c13.webp";